module.exports = __webpack_public_path__ + "static/img/ent-2.97b1f3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-2.jpg
// module id = wkG1
// module chunks = 52